import React, { useState } from 'react';
import { Box, Button } from '@material-ui/core';
import { Link } from "react-router-dom";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Copyright from './Footer/Copyright';
// import ContactModal from './Footer/ContactModal';
import '../css/Footer.scss';

function Footer(props) {
    // const [open, setOpen] = useState(false);
    // const { values, inputChangeHandle } = props;
    const { values } = props;
    // const modalOpen = () => {
    //     props.resetFormParam();
    //     setOpen(true);
    // }
    // const modalClose = () => {
    //     setOpen(false);
    // }
    return (
        <Box id="footer" className="footer">
            <div className="footer-btn-group" style={values.naviVisible.button}>
                {/* <Button size="large" variant="contained" color="primary" onClick={modalOpen} startIcon={<MailOutlineIcon />}> */}
                <Button size="large" variant="contained" color="primary" component={Link} to="https://www.tokyo-fabric.co.jp/contact/" target="_contract" startIcon={<MailOutlineIcon />}>
                    技術相談・問い合わせ
                </Button>
                {/* <ContactModal values={values} open={open} modalClose={modalClose} inputChangeHandle={inputChangeHandle} /> */}
            </div>
            <Copyright />
        </Box>
    )
}

export default Footer;